/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Feet_DownInputs */

const en_us2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both feet flat on the floor.`)
};

const pt_br2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois pés no chão.`)
};

const es_419_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los dos pies apoyados en el suelo.`)
};

const pt_pt2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois pés no chão.`)
};

const fr_fr2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux pieds à plat au sol.`)
};

const de_de2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide Füße flach auf den Boden.`)
};

const it_it2_body_assessment_cue_feet_down = /** @type {(inputs: Body_Assessment_Cue_Feet_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambi i piedi ben a terra.`)
};

/**
* | output |
* | --- |
* | "Both feet flat on the floor." |
*
* @param {Body_Assessment_Cue_Feet_DownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_feet_down = /** @type {((inputs?: Body_Assessment_Cue_Feet_DownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Feet_DownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_feet_down(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_feet_down(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_feet_down(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_feet_down(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_feet_down(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_feet_down(inputs)
	return en_us2_body_assessment_cue_feet_down(inputs)
});
export { body_assessment_cue_feet_down as "body-assessment.cue.feet_down" }